import React, { useState } from "react";
import Pagination from "./Pagination";
import { Link } from "react-router-dom";
import { StatusBadge } from "../utils/tableUtils";

const DashboardTable = ({
  headers,
  data = [],
  pageSize = 10,
  type = "Food Outlet",
  currentPage: controlledCurrentPage,
  totalCount,
  onPageChange,
  useServerPagination = false,
}) => {
  const [localCurrentPage, setLocalCurrentPage] = useState(1);
  const currentPage = controlledCurrentPage || localCurrentPage;

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  const currentTableData = useServerPagination
    ? data
    : data?.slice(startIndex, endIndex);
  const paginationTotalCount = useServerPagination ? totalCount : data.length;
  const handlePageChange = onPageChange || setLocalCurrentPage;

  return (
    <>
      <div className="border-2 border-t-4 border-quaternary bg-[#F7F9F8] text-[#413F3F] overflow-x-scroll relative rounded-xl h-full">
        <div className="w-full">
          <table className="w-full table-auto divide-y divide-gray-200 dark:divide-gray-700">
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th
                    key={index}
                    className="text-start text-sm font-bold p-3 whitespace-nowrap"
                  >
                    {header}
                  </th>
                ))}
                {data.length > 0 && <th className="w-24"></th>}
              </tr>
            </thead>
            {data.length > 0 ? (
              type === "Hubspots" ? (
                <tbody className="divide-y divide-[#8D8D8D]">
                  {currentTableData.map((item, index) => (
                    <tr
                      key={index}
                      className={`${index % 2 === 0 ? "bg-gray-100" : ""}`}
                    >
                      <td className="p-3 text-sm font-medium">
                        {startIndex + index + 1}
                      </td>
                      <td className="p-3 text-sm font-medium truncate max-w-xs">
                        {item?.hexString}
                      </td>
                      <td className="p-3 text-sm font-medium">
                        {item?.orderCount}
                      </td>
                      <td className="p-3 text-right">
                        <Link
                          to={`/?s=${item?.hexString}`}
                          className="border border-quaternary text-quaternary font-semibold px-3 py-1.5 rounded-md whitespace-nowrap"
                        >
                          Details
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="divide-y divide-[#8D8D8D]">
                  {currentTableData.map((item, index) => (
                    <tr
                      key={index}
                      className={`${index % 2 === 0 ? "bg-gray-100" : ""}`}
                    >
                      <td className="p-3 text-sm font-medium">
                        {startIndex + index + 1}
                      </td>
                      <td className="p-3 text-sm font-medium truncate max-w-xs">
                        {item?.orderId}
                      </td>
                      <td className="p-3 text-sm font-medium truncate max-w-xs">
                        {item?.outlet_name || item?.outlet || "—"}
                      </td>
                      <td className="p-3 text-sm font-medium">
                        <StatusBadge status={item?.status} />
                      </td>
                      <td className="p-3 text-sm font-medium truncate max-w-xs">
                        {item?.driver_name || item?.driver || "—"}
                      </td>
                      {/* <td className="pl-[18px] py-4 break-words text-sm font-medium">
                        {" "}
                        {item?.driver_contact_no || "N/A"}{" "}
                      </td>
                      <td className="pl-[18px] py-4 break-words text-sm font-medium">
                        {" "}
                        {(item?.commission && `£${item?.commission}`) ||
                          "N/A"}{" "}
                      </td>
                      <td className="pl-[18px] py-4 break-all text-sm font-medium">
                        {" "}
                        {item?.stackId ? "Yes" : "No"}{" "}
                      </td> */}
                      <td className="p-3 text-right break-words text-sm font-medium">
                        <Link
                          to={`/orders/${item?._id}`}
                          className="bg-quaternary text-white font-semibold w-32 block py-1.5 rounded-md shadow-[rgba(50,50,93,0.25)_0px_6px_12px_-2px,_rgba(0,0,0,0.3)_0px_3px_7px_-3px] whitespace-nowrap text-center"
                        >
                          Details
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )
            ) : (
              <tbody>
                <tr>
                  <td
                    colSpan={headers.length + 1}
                    className="p-4 italic text-sm font-medium text-center"
                  >
                    No deliveries yet — rumor has it, the driver's waiting for
                    the perfect weather.
                  </td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </div>
      <div className="flex justify-center mt-4">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={paginationTotalCount}
          pageSize={pageSize}
          onPageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default DashboardTable;
